<template>
  <gj-modal
      size="1300_auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增广告组</template>
    <template #content>
<!--      <p>{{form | json}}</p>-->
      <el-form
          ref="form"
          :model="form"
          >
        <app-add-title>广告组</app-add-title>
        <app-base-info
            ref="base"
            :market-id="marketId"
            :form="form.baseInfoForm"
            :campaign="campaign"
            group-input
            @input-campaign-option="inputCampaignOption"
        ></app-base-info>
        
        <!-- <el-divider></el-divider> -->
        
        <app-add-title>商品</app-add-title>
        <app-product-picker
            ref="productPicker"
            :market-id="marketId"
            :form="form.productPickerForm"
            title="商品"
        ></app-product-picker>
  
        <!-- 手动投放 -->
        <template v-if="manual">
  
          <el-divider style="margin-top: 30px;"></el-divider>
          <app-add-title>关键词与竞价</app-add-title>
          <app-keyword-bid-picker
              ref="keywordBidPicker"
              :market-id="marketId"
              :form="form"
              :asin-list="pickedAsinList"
          ></app-keyword-bid-picker>
          
          <!-- 关键词投放 -->
          <template v-if="keywordTarget">
            <el-divider style="margin-top: 30px;"></el-divider>
            <app-add-title>否定关键词（选填）</app-add-title>
            <app-neg-keyword-picker
                :form="form.negKeywordPickerForm"
                title="否定关键词"
                :match-type-option="AdNegKeywordEnum.SP.matchTypeOption"
            ></app-neg-keyword-picker>
          </template>
          <!-- 商品投放 -->
          <template v-if="productTarget">
            <el-divider style="margin-top: 30px;"></el-divider>
            <app-add-title>否定商品投放（选填）</app-add-title>
            <app-manual-neg-target-picker
                v-if="manual"
                :market-id="marketId"
                :form="form.manualNegTargetPickerForm"
                title="否定商品"
            ></app-manual-neg-target-picker>
          </template>
        </template>
  
        <!-- 自动投放 -->
        <template v-if="auto">
          <el-divider style="margin-top: 30px;"></el-divider>
          <app-add-title>竞价</app-add-title>
          <app-bid-picker
              ref="bidPicker"
              :form="form.bidPickerForm"
          ></app-bid-picker>
    
          <el-divider style="margin-top: 30px;"></el-divider>
          <app-add-title>否定关键词（选填）</app-add-title>
          <app-neg-keyword-picker
              :form="form.negKeywordPickerForm"
              title="否定关键词"
              :match-type-option="AdNegKeywordEnum.SP.matchTypeOption"
          ></app-neg-keyword-picker>
    
          <el-divider style="margin-top: 30px;"></el-divider>
          <app-add-title>否定商品投放（选填）</app-add-title>
          <app-auto-neg-target-picker
              :market-id="marketId"
              :form="form.autoNegTargetPickerForm"
              title="否定商品"
          ></app-auto-neg-target-picker>
        </template>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import AppBaseInfo from "../common/base-info";
  import AppAddTitle from "../common/title";
  import AppProductPicker from "../common/product-picker";
  import AppNegKeywordPicker from "../common/neg-keyword-picker";
  import AppAutoNegTargetPicker from "../common/auto-neg-target-picker";
  import AppBidPicker from "../common/bid-picker";
  import AppKeywordBidPicker from "../common/keyword-bid-picker";
  import AppManualNegTargetPicker from "../common/manual-neg-target-picker";
  import { modalMixIn } from "@/minxins";
  import { SP } from "@/api/ad";
  import { defaultVal, isMeaningful } from "@/utils/common";
  import { AdBidTypeEnum, AdCampaignEnum, AdGroupEnum, AdKeywordEnum, AdNegKeywordEnum, GroupType} from "../../../../../common/enum";
  import {adStoreMixin} from "@/views/modules/ad/common/mixin";

  export default {
    name: "app-add-sp-ad-group",
    mixins: [modalMixIn,adStoreMixin],
    components: {
      AppManualNegTargetPicker,
      AppKeywordBidPicker,
      AppBidPicker,
      AppAutoNegTargetPicker,
      AppNegKeywordPicker,
      AppProductPicker, AppAddTitle, AppBaseInfo
    },
    props: {
      marketId: {
        required: true
      },
      campaign: {
        required: false,
        default: null
      },
    },
    data() {
      return {
        form: {
          defaultBid: null,
          baseInfoForm: {
            campaignTargetType: AdGroupEnum.SP.targetingType.ALL,
            campaignId: null,
            groupName: null,
          },
          productPickerForm: {
            items: []
          },
          negKeywordPickerForm: {
            items: [],
            matchType: AdNegKeywordEnum.SP.matchType.NEGATIVE_EXACT
          },
          manualNegTargetPickerForm: {
            items: []
          },
          autoNegTargetPickerForm: {
            items: []
          },
          keywordPickerForm: {
            defaultBid: 0.75,
            items: [],
            inputMatchTypes: [
              AdKeywordEnum.SP.matchType.EXACT
            ],
            matchType: AdKeywordEnum.SP.matchType.EXACT,
            matchTypes: [
              AdKeywordEnum.SP.matchType.EXACT,
              AdKeywordEnum.SP.matchType.PHASE,
              AdKeywordEnum.SP.matchType.BROAD
            ],
            bid: null,
          },
          targetType: AdGroupEnum.SP.targetingType.KEYWORD,
          bidPickerForm: {
            bidType: AdBidTypeEnum.default,
            defaultBid: null,
            items: [],
          },
          productTargetPickerForm: {
            items: []
          }
        },
        AdNegKeywordEnum: AdNegKeywordEnum,
        campaignOption: null
      }
    },
    created() {
      this.form.defaultBid = this.adStore.SP.defaultBid;
      this.form.bidPickerForm.defaultBid = this.adStore.SP.defaultBid;
      this.form.keywordPickerForm.defaultBid = this.adStore.SP.defaultBid;
      if (isMeaningful(this.campaign)) {
        this.campaignOption = this.campaign;
      }
    },
    computed: {
      manual() {
        return this.campaignOption && this.campaignOption.targetingType === AdCampaignEnum.SP.targetingType.MANUAL;
      },
      auto() {
        return this.campaignOption && this.campaignOption.targetingType === AdCampaignEnum.SP.targetingType.AUTO;
      },
      keywordTarget() {
        return this.campaignOption && this.form.targetType === AdGroupEnum.SP.targetingType.KEYWORD;
      },
      productTarget() {
        return this.campaignOption && this.form.targetType === AdGroupEnum.SP.targetingType.PRODUCT;
      },
      pickedAsinList() {
        return (this.form.productPickerForm.items || []).map(e => e.asin);
      }
    },
    methods: {
      checkFrom(ref) {
        return new Promise((resolve, reject) => {
          if(!ref) return resolve();
          ref.validate(valid => {
            valid ? resolve() : reject()
          });
        })
      },
      inputCampaignOption(option) {
        this.campaignOption = option;
      },

      confirm() {
        this.confirmLoading = true;
        let formValid = ['base', 'productPicker', 'keywordBidPicker', 'bidPicker']
          .map(e => this.$refs[e]?.formValidate());
        Promise.all([...formValid])
          .then(() => this.groupsAdd())
          .catch((error) =>console.warn('zs', error))
          .complete(() => this.confirmLoading = false)
      },
      
      // 商品广告创建构建请求数据
      async groupsAddParams() {
        // 关键词参数
        const keywordsParams = {
          marketId: this.marketId,
          params: this.form.keywordPickerForm.items.map(item => ({
            keywordText: item.keyword,
            matchType: item.matchType,
            bid: item.bid
          }))
        };
        // 否定关键词参数
        const negativeKeywordsParams = {
          marketId: this.marketId,
          params: this.form.negKeywordPickerForm.items.map(item => ({
            keywordText: item.keyword,
            matchType: item.matchType
          }))
        };
        // 商品投放参数
        const targetsParams = {
          marketId: this.marketId,
          params: this.form.productTargetPickerForm.items.map(item => ({
            bid: item.bid,
            categoryId: defaultVal(item.categoryId, null),
            categoryName: defaultVal(item.categoryName, null),
            asin: defaultVal(item.asin, null),
            brandId: defaultVal(item.brandId, null),
            brandName: defaultVal(item.brandName, null),
            minPrice: defaultVal(item.lowPrice, null),
            maxPrice: defaultVal(item.maxPrice, null),
            minMarks: (item.marks && item.marks.length !== 0) ? item.marks[0] : null,
            maxMarks: (item.marks && item.marks.length !== 1) ? item.marks[1] : null,
            prime: defaultVal(item.prime, null),
          }))
        };
        // 投放组参数
        const targetsGroupsParams = {
          marketId: this.marketId,
          params: this.form.bidPickerForm.items
            .map(item => ({
              bid: item.bid,
              targetingGroupType: item.id,
              state: item.status ? 0 : 1
            }))
        };
        // 自动否定商品投放参数
        const autoNegativeTargetsParams = {
          marketId: this.marketId,
          params: this.form.autoNegTargetPickerForm.items.map(item => ({
            asin: item.asin
          }))
        };
        // 手动动否定商品投放参数
        const manualNegativeTargetsParams = {
          marketId: this.marketId,
          params: this.form.manualNegTargetPickerForm.items.map(item => ({
            asin: defaultVal(item.asin, null),
            brandId: defaultVal(item.brandId, null),
            brandName: defaultVal(item.brandName, null)
          }))
        };
        // 新增参数
        let params = {
          marketId: this.marketId,
          params: [{
            groupName: this.form.baseInfoForm.groupName,
            campaignId: this.form.baseInfoForm.campaignId,
            campaignName: this.form.baseInfoForm.campaignName,
            defaultBid: this.form.defaultBid || null,
            productParams: {
              marketId: this.marketId,
              params: this.form.productPickerForm.items.map(item => ({
                asin: item.asin,
                sku: item.msku
              }))
            },
          }]
        }
        let add = {};
        // 广告组类型
        this.keywordTarget && ( params.params[0].groupTargetingType = GroupType().SP.cell.keyword );
        this.productTarget && ( params.params[0].groupTargetingType = GroupType().SP.cell.product );
        this.auto && ( params.params[0].groupTargetingType = GroupType().SP.cell.auto );
        // 自动投放时
        if(this.auto) {
          add = {
            negativeKeywordsParams ,
            negativeTargetsParams: autoNegativeTargetsParams
          }
          // 投放组竞价
          if (this.form.bidPickerForm.bidType === AdBidTypeEnum.targetGroup) {
            add.targetsGroupsParams = targetsGroupsParams
          }
          // 默认竞价
          params.params[0].defaultBid = this.form.bidPickerForm.defaultBid
        }
        // 关键词投放时
        if(this.manual && this.keywordTarget) {
          add = { keywordsParams, negativeKeywordsParams }
        }
        // 商品投放时
        if(this.manual && this.productTarget) {
          add = { targetsParams, negativeTargetsParams: manualNegativeTargetsParams }
        }
        Object.assign(params.params[0], add)
        return params;
      },
      // 广告组创建
      async groupsAdd() {
        this.confirmLoading = true;
        try {
          const params = await this.groupsAddParams();
          const { data, msg } = await SP.groupsAdd(params);
          this.$gjMessage.success(msg);
          this.$gjDestroy();
          this.$emit('created');
        } catch (error) {
          console.warn(error);
        } finally {
          this.confirmLoading = false;
        }
        
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../common/common";
  
</style>
